// Colour options — brief §4.4 item 3 (P42), 2026-09-24: tonal chips, each a
// DOT that IS the value (the colour token itself) and a LABEL that stays ink.
// A colour pick is a CHOICE control, so the chosen chip is the D-1 inversion
// (`highlight` fill + `highlight-reversed` ink); its dot keeps the colour.
//
// The tonal fill mixes the chip's OWN ink (Rule 67: a tint of currentColor
// follows the ink per scheme): 14% at rest, 22% on hover, 30% pressed. Each
// step clears Rule 65's 0.02 luminance floor on the white and on the dark
// card (computed in __tests__/appFieldColors.test.js).
//
// Contract: the shared AppChoiceGroup's — `options` [{ value, label }] where
// `value` is a brand colour token ('blue', 'green', …), and `stateKey`, the
// state key a click writes. The label is a bundle key or a plain string.
export const AppColorChip = {
  tag: 'button',
  type: 'button',
  flow: 'x',
  align: 'center',
  gap: 'Y',
  minHeight: 'controlHCompact',
  padding: '0 Z1',
  round: 'radiusPill',
  borderWidth: '0',
  cursor: 'pointer',
  fontSize: 'Z2',
  fontWeight: '500',
  color: 'title',
  background: 'color-mix(in srgb, currentColor 14%, transparent)',
  ':hover': { background: 'color-mix(in srgb, currentColor 22%, transparent)' },
  ':active': { background: 'color-mix(in srgb, currentColor 30%, transparent)' },
  '.isActive': { background: 'highlight', color: 'highlight-reversed' },
  '@coarse': { minHeight: 'controlH' },

  Dot: {
    tag: 'span',
    'aria-hidden': true,
    boxSize: 'Z',
    flexShrink: '0',
    round: 'radiusPill',
    background: (el) => el.parent?.optionValue
  },

  Label: {
    tag: 'span',
    text: (el) => el.call('polyglot', el.parent?.optionLabel ?? '')
  }
}

export const AppColorChips = {
  extends: 'AppChoiceGroup',
  childExtends: 'AppColorChip',
  flow: 'x',
  flexWrap: 'wrap',
  gap: 'Y'
}

export const AppFieldColors = {
  extends: 'AppField',
  // A choice group is not a <label> — see AppFieldSegmented.
  tag: 'div',
  AppColorChips: {
    ariaLabel: (el) => el.call('polyglot', el.parent?.label || ''),
    options: (el) => el.parent?.options,
    stateKey: (el) => el.parent?.stateKey
  }
}
